import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const COLS = [
  { h: "Company", links: [["About", "/mission"], ["Mission", "/mission"], ["Founder", "/founder"], ["Careers", "/careers"], ["Newsroom", "/newsroom"]] },
  { h: "Technology", links: [["Products", "/technology"], ["Companies", "/companies"], ["ImJove Labs", "/labs"], ["ImJove Universe", "/universe"]] },
  { h: "Connect", links: [["Partnerships", "/contact"], ["Investors", "/contact"], ["Press", "/contact"], ["Contact", "/contact"]] },
  { h: "Legal", links: [["Privacy", "/legal/privacy"], ["Terms", "/legal/terms"], ["Cookies", "/legal/cookies"]] },
];

export default function Footer() {
  const { content } = useContent();
  const social = content.social_links || {};
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-white/10 bg-ink-900">
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={content.logo_url} alt="ImJove Tech" className="h-10 w-10 object-contain" />
              <span className="font-display text-lg font-semibold uppercase tracking-brand">
                ImJove<span className="text-gold"> Tech</span>
              </span>
            </div>
            <p className="mt-5 font-mono2 text-xs uppercase tracking-[0.3em] text-gold-light/80">
              Imagine. Build. Evolve.
            </p>
            <p className="mt-4 max-w-xs font-body text-sm text-white/45">
              Building technology for the next era. We don't wait for the future. We build it.
            </p>
            <div className="mt-6 flex gap-3">
              {[[Instagram, social.instagram || "https://instagram.com/ImJoveTech", "instagram"], [Facebook, social.facebook || "https://facebook.com/ImJoveTech", "facebook"]].map(
                ([Icon, href, key]) => (
                  <a
                    key={key}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={key}
                    data-testid={`footer-social-${key}`}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-white/50 transition-colors hover:border-gold/50 hover:text-gold-light"
                  >
                    <Icon size={15} />
                  </a>
                )
              )}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.h}>
              <h4 className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-white/40">{c.h}</h4>
              <ul className="mt-5 space-y-3">
                {c.links.map(([label, to]) => (
                  <li key={label + to}>
                    <Link to={to} className="font-body text-sm text-white/60 transition-colors hover:text-gold-light">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <p className="font-mono2 text-xs text-white/35">© {new Date().getFullYear()} ImJove Tech. All Rights Reserved.</p>
          <div className="flex items-center gap-5">
            <p className="font-mono2 text-xs text-white/35">Founded & led by Jove Divinity</p>
            <Link to="/admin" data-testid="footer-admin-link" className="font-mono2 text-xs uppercase tracking-widest text-white/35 transition-colors hover:text-gold-light">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
